<div id="safety-app-coaching" ng-controller="CoachingCtrl"></div>